import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { List } from 'material-ui';
import CustomerRow from '../CustomerRow';
import './CategoryTemplate.css';

const CategoryTemplate = (props) => {
  return (
    <>
      <div>
        <List>
          <CustomerRow
            disabledNoFeedback
            customer={props.customer}
          ></CustomerRow>
        </List>
      </div>
      <div className="category-template-name">
        <h3 className="subheader">{props.categoryName}</h3>
      </div>
      <div>{props.children}</div>
      <div className="category-template-actions">
        <div>
          <RaisedButton
            label={props.backLabel || 'Back'}
            primary
            onClick={props.handleBack}
          />
        </div>
        <div>
          <RaisedButton
            label={props.nextLabel || 'Next'}
            primary
            onClick={props.handleNext}
          />
        </div>
      </div>
    </>
  );
};

CategoryTemplate.propTypes = {
  handleNext: PropTypes.func.isRequired,
  categoryName: PropTypes.string.isRequired,
  customer: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  nextLabel: PropTypes.string
};

export default CategoryTemplate;
